import React from 'react'
import styled from 'styled-components'
import _MediaPlayer from 'components/mediaPlayer'

const MediaPlayer = styled((props) => <_MediaPlayer {...props} />)`
  display: flex;
  align-items: center;
  width: 100%;
  height: 562.5px !important;

  @media (max-width: 820px) {
    height: 461.25px !important;
  }
  @media (max-width: 768px) {
    height: 432px !important;
  }
  @media (max-width: 720px) {
    height: 405px !important;
  }
  @media (max-width: 640px) {
    height: 360px !important;
  }
  @media (max-width: 512px) {
    height: 288px !important;
  }
  @media (max-width: 448px) {
    height: 252px !important;
  }
  @media (max-width: 425px) {
    height: 239px !important;
  }
  @media (max-width: 352px) {
    height: 198px !important;
  }
  @media (max-width: 320px) {
    height: 180px !important;
  }
  @media (max-width: 280px) {
    height: 157.5px !important;
  }
`

export default MediaPlayer
